export const defaultIntersectionVisibleOptions = {
    rootMargin: '200% 0px',
};
//# sourceMappingURL=constants.js.map